module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-banner-he.bc2999f5.png";